import { render, staticRenderFns } from "./MonitoramentoWebhooks.vue?vue&type=template&id=2453971c&scoped=true"
import script from "./MonitoramentoWebhooks.vue?vue&type=script&lang=js"
export * from "./MonitoramentoWebhooks.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoWebhooks.vue?vue&type=style&index=0&id=2453971c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453971c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2453971c')) {
      api.createRecord('2453971c', component.options)
    } else {
      api.reload('2453971c', component.options)
    }
    module.hot.accept("./MonitoramentoWebhooks.vue?vue&type=template&id=2453971c&scoped=true", function () {
      api.rerender('2453971c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MonitoramentoWebhooks.vue"
export default component.exports